export const isInIframe = () => window.location !== window.parent.location;

export const toOrigin = (value: string | null | undefined): string | null => {
  if (!value) {
    return null;
  }

  try {
    return new URL(value).origin;
  } catch {
    return null;
  }
};

export const resolveParentOrigin = (): string | null => {
  const urlParams = new URLSearchParams(window.location.search);

  return toOrigin(urlParams.get('parentOrigin'));
};
